import React from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
  dateTimeToserver,
} from "lib/helpers";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { TextArea } from "components/form";
import cleanObject from "utils/editHelper";
import { GalleryField } from "components/form";
import MultySearchSelect from "utils/MultySearchSelect";
import initItem from "utils/initItem";
import extractValues from "utils/extractValues";
import SocialComponent from "utils/SocialComponent";
import MetaDataComponent from "utils/MetaDataComponent";
import TextFieldSlug from "components/form/TextFieldSlug";
// components

const surfaceTypes = [
  { label: "چمن طبیعی", value: "grass" }, // Grass: چمن طبیعی
  { label: "چمن مصنوعی", value: "artificial" }, // Artificial: چمن مصنوعی
  { label: "چمن ترکیبی", value: "hybrid" }, // Hybrid: چمن ترکیبی
];

export default function Edit(props) {
  const core = useCore();
  const { show, item } = props;

  const config = {
    matches: {
      valueField: "id",
      labelFields: [
        "homeTeam.translations.fa.name",
        "awayTeam.translations.fa.name",
      ],
    },
  };
  const updatedItem = initItem(item, config);

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={updatedItem}
          onSubmit={async (values, { setSubmitting }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const clean = cleanObject(values, [
              "id",
              "uuid",
              "updatedAt",
              "createdAt",
              "news",
              "videos",
              "statistics",
            ]);
            const result = extractValues(clean, ["matches"]);

            await props.submit(result, item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="translations.fa.name"
                    slugFieldName="translations.fa.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="نام(en)"
                    label="نام (en):"
                    name="translations.en.name"
                    slugFieldName="translations.en.slug"
                    component={TextFieldSlug}
                  />

                  <Field
                    placeholder="کشور"
                    label="کشور :"
                    name="translations.fa.countryLocation"
                    component={TextField}
                  />
                  <Field
                    placeholder="کشور(en)"
                    label="کشور(en) :"
                    name="translations.en.countryLocation"
                    component={TextField}
                  />

                  <Field
                    placeholder="شهر"
                    label="شهر :"
                    name="translations.fa.cityLocation"
                    component={TextField}
                  />
                  <Field
                    placeholder="شهر(en)"
                    label="شهر(en) :"
                    name="translations.en.cityLocation"
                    component={TextField}
                  />

                  <Field
                    placeholder="نامک"
                    label="نامک:"
                    name="translations.fa.slug"
                    component={TextField}
                  />
                  <Field
                    placeholder="نامک(en)"
                    label="نامک(en) :"
                    name="translations.en.slug"
                    component={TextField}
                  />

                  <Field
                    label=" مسابقات:"
                    name="matches"
                    component={MultySearchSelect}
                    searchFields="homeTeam.translations.name,awayTeam.translations.name"
                    collectionName="match"
                    showFields="homeTeam.translations.name,awayTeam.translations.name,matchDate"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <div className="intro-y">
                    <span>ظرفیت :</span>
                    <Field
                      label=" ظرفیت: "
                      name="capacity"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label="نوع زمین :"
                      name="surfaceType"
                      component={Select}
                      options={surfaceTypes}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <Field
                    label="ایا سقف دارد :"
                    name="hasRoof"
                    component={Select}
                    options={[
                      { value: true, label: "بله" },
                      { value: false, label: "خیر " },
                    ]}
                    className="w-full px-3 py-2 border rounded"
                  />
                </div>
                <div className="w-full flex justify-between">
                  <div className="w-full">
                    <Field
                      label="تصویر"
                      name="image"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>

                <SocialComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Stadium"
                />
                <MetaDataComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Stadium"
                />
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
